module.exports = __webpack_public_path__ + "img/576x957px_mittel_im-tab-Safari-PSD-Mockup-3.935e7e5f.jpg";